module.exports = __webpack_public_path__ + "img/mi-construction.8b7b6946.svg";